import operatorApiService from "../../../services/operator-api.service";

export function sendOneVehicleLog() {
  const data = `oneVehiclelog:[${getCurrentFormattedTime()}]`;
  operatorApiService.doPostLogForOnevehicle({ data });
}

function getCurrentFormattedTime(): string {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = ("0" + (now.getMonth() + 1)).slice(-2);
  const dd = ("0" + now.getDate()).slice(-2);
  const hour = ("0" + now.getHours()).slice(-2);
  const min = ("0" + now.getMinutes()).slice(-2);
  const sec = ("0" + now.getSeconds()).slice(-2);
  const ms = ("000" + now.getMilliseconds()).slice(-3);

  return `${yyyy}-${mm}-${dd} ${hour}:${min}:${sec}.${ms}`;
}
